import React from "react";
import { _get, _post } from "../../Api";
import { getArticles } from "../../store/articles/ArticlesApi";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { IconButton, ListItemIcon } from "@material-ui/core";
import { Done, ErrorOutline, Sync } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import cloudStore from "../../store/CloudStore";

function MerchantSyncButton() {
  const [refreshing, setRefreshing] = React.useState("NONE");

  const handleRefresh = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setRefreshing("REFRESHING");
    _post("/nova/v2/merchants/" + cloudStore.merchant.id + "/sendMerchantUpdatedEvent")
      .then(() => {
        setRefreshing("DONE");
      })
      .catch((e) => {
        console.log(e);
        setRefreshing("ERROR");
      });
  };

  return (
    <AuthorizationWrapper
      permission={"sync.merchant"}
      child={
        <ListItemIcon>
          <IconButton title={"Synchroniseren"} onClick={handleRefresh}>
            {refreshing === "NONE" ? (
              <Sync />
            ) : refreshing === "REFRESHING" ? (
              <CircularProgress size={20} color="primary" />
            ) : refreshing === "ERROR" ? (
              <ErrorOutline />
            ) : refreshing === "DONE" ? (
              <Done />
            ) : (
              <Sync />
            )}
          </IconButton>
        </ListItemIcon>
      }
    />
  );
}

export default MerchantSyncButton;
